module.exports = __webpack_public_path__ + "static/media/رحلات إلى جنيف.9754cb43.jpg";